<template>
<div>
  <v-container fluid grid-list-md>
  <v-progress-circular
      v-if="this.saving"
      indeterminate
      color="green"
    ></v-progress-circular>
  <v-data-table
    dense
    :headers="headers"
    :items="mldetails"
    :search="search"
    :custom-filter="filtrirajRed"
    sort-by="bankStatmentNumberDetail"
    class="bs-tablica"
    :fixed-header="mldetails.length > 12"
    :height="mldetails.length > 12 ? '62vh' : undefined"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50]
    }"
    :items-per-page="50"
    @click:row="haveAlert"
  >
    <template v-slot:top>
      <v-toolbar flat class="bs-glava">
        <v-toolbar-title class="bs-naslov">{{lang.bankStatments}}</v-toolbar-title>
        <span class="bs-brojke">
          <span class="bs-oz bs-oz-ok">{{ brojStatusa.proknjizeno }} proknjiženo</span>
          <span v-if="brojStatusa.djelomicno" class="bs-oz bs-oz-dj">{{ brojStatusa.djelomicno }} djelomično</span>
          <span class="bs-oz bs-oz-otv">{{ brojStatusa.otvoreno }} otvoreno</span>
        </span>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field
            class="bs-trazi"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            dense
            v-model="search"
          ></v-text-field>
  
        <v-spacer></v-spacer>
        <v-btn small color="primary" class="mr-2" @click="prijedlogOtvoren = true">
          <v-icon small left>mdi-auto-fix</v-icon>Prijedlog knjiženja
        </v-btn>
        <MainLedgerIzvodPrijedlog v-model="prijedlogOtvoren" @potvrdjeno="ucitajStavke" />
        <v-dialog v-model="dialog" max-width="700px">

          <v-card>
            <v-card-title>
              <span class="headline">{{ lang.bankStatment }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                <v-row no-gutters>
                    <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pr-2">
                      {{lang.bankStatment}}
                    </v-col>
                    <v-col cols="12" sm="10" md="10" lg="10" xl="10">

                    </v-col>
                </v-row>
                <v-row no-gutters> 
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pr-2">
                    <v-text-field
                      v-model="editedItem.HomeCurrency"
                      :label="lang.HomeCurrency"
                      required
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                    <v-text-field
                      v-model="editedItem.Debit"
                      :label="lang.Debit"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                    <v-text-field
                      v-model="editedItem.Credit"
                      :label="lang.Credit"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters> 
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pr-2">
                    <v-text-field
                      v-model="editedItem.ForeignCurrency"
                      :label="lang.ForeignCurrency"
                      required
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                    <v-text-field
                      v-model="editedItem.DebitForegin"
                      :label="lang.DebitFr"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                    <v-text-field
                      v-model="editedItem.CreditForegin"
                      :label="lang.CreditFr"
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>

                  <v-row no-gutters>
                    <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pr-2">
                      <v-text-field
                        v-model="editedItem.VATPer"
                        :label="lang.VATPer"
                        maxlength="2"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="10" md="10" lg="10" xl="10">
                      <v-text-field
                        v-model="editedItem.Description"
                        :label="lang.Description"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-if="errorMatch">                    
                      <div class="red" v-html="errorMatch" />
                  </v-row>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{langC.Cancel}}</v-btn>
                    <v-btn :disabled="!valid" color="success" text @click="save">{{langC.Save}}</v-btn>  
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
 
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
 
    <template v-slot:[`item.action`]="{ }">

    </template>
    <template v-slot:no-data>
      {{ lang.bankStatmentEmpty }}
    </template>
    <template v-slot:[`item.bankStatmentNumberDetail`]="{ item }">
      <span class="bs-rbr">{{ item.bankStatmentNumberDetail }}</span>
    </template>
    <template v-slot:[`item.ClosedAccount`]="{ item }">
      <span :class="['bs-oz', 'bs-oz-' + statusRetka(item).klasa]">
        <v-icon v-if="statusRetka(item).klasa === 'ok'" x-small color="green darken-2">mdi-check</v-icon>{{ statusRetka(item).tekst }}
      </span>
    </template>
    <template v-slot:[`item.partnerName`]="{ item }">
      <div class="bs-redak1">
        <span class="bs-partner" :title="item.partnerName">{{ item.partnerName || '—' }}</span>
        <span v-if="item.partnerBankIBAN" class="bs-sitno bs-iban">{{ item.partnerBankIBAN }}</span>
      </div>
      <div v-if="pozivi(item)" class="bs-sitno bs-redak2" :title="pozivi(item)">{{ pozivi(item) }}</div>
    </template>
    <template v-slot:[`item.bankDescription`]="{ item }">
      <div class="bs-opis" :title="item.bankDescription">{{ item.bankDescription }}</div>
      <div v-if="item.bankCode" class="bs-sitno bs-redak2" :title="'šifra: ' + item.bankCode">šifra: {{ item.bankCode }}</div>
    </template>
    <template v-slot:[`item.bankStatmentDebit`]="{ item }">
      <span v-if="broj(item.bankStatmentDebit)" class="bs-iznos bs-d">{{ formatPrice(item.bankStatmentDebit) }}<small>D</small></span>
      <span v-else class="bs-nula">–</span>
    </template>
    <template v-slot:[`item.bankStatmentCredit`]="{ item }">
      <span v-if="broj(item.bankStatmentCredit)" class="bs-iznos bs-p">{{ formatPrice(item.bankStatmentCredit) }}<small>P</small></span>
      <span v-else class="bs-nula">–</span>
    </template>
  </v-data-table>

  <v-dialog
        v-model="showAlert"
        max-width="350"
      >
      <v-card>
        <v-card-title class="headline">
          {{alertText1}}
        </v-card-title>

        <v-card-text>
          {{alertText2}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="showAlert = false"
          >
            {{langC.Cancel}}
          </v-btn>

          <v-btn
            color="blue"
            text
            @click="haveAlert2()"
          >
            {{langC.Continue}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  </div>
</template>

<script>
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'
import MainLedgerService from '@/services/MainLedgerService'
import MainLedgerIzvodPrijedlog from './MainLedgerIzvodPrijedlog'

  export default {
    name: 'mldetailbsCRUD',
    components: { MainLedgerIzvodPrijedlog },
    data: () => ({
      prijedlogOtvoren: false,
      documentName: '',
      documentNameLoc: '',
      search: '',
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal2: false,
      menu2: false,
      lang: {},
      langC: {},
      saving: false,
      error: null,
      errorMatch: null,
      modal: false,
      show1: false,
      show2: false,
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        documentName: "",
        databaseDocID: 0
      },
      dialog: false,
      headers: [ 
      ],
      mldetails: [],
      localAcc1: '',
      localAcc2: '',
      localAcc3: '',
      editedIndex: -1,
      editedItem: {},
      defaultItem: {
      },
      confpassword: '',
      privitems: [ ],
      valid: true,
      showDetails: true,
      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Password must be 6 or more characters',
      ],
      account4Rules: [
        v => !!v || 'Account is required',
        v => (v && v.length >= 4) || 'Account must be 4 to 6 characters',
      ],
      locusers: [],
      select: { },
      selectA4: {},

      sumML: {
        Debit: 0,
        Credit: 0,
        DebitForegin: 0,
        CreditForegin: 0
      },
      mainQuery2: {
        CompanyId: 1,
        account4: '',
        databaseMLID: 0,
        businessYear: 0
      },
      currnecyType: [
        { text: 'EUR', value: 'EUR' },
        { text: 'Kn', value: 'Kn' },
        { text: 'USD', value: 'USD' },
        { text: 'GBP', value: 'GBP' },
        { text: 'CHF', value: 'CHF' }
      ],
      money: {
        prefix: '= ',
        suffix: ' ',
        precision: 3
      },
      price: 7.538,
      docSide: 0,
      account4: {},
      newItem: {},
      exRate: 7.538,
      showAlert: false,
      type: null,
      alertText1: null,
      alertText2: null,
      para: {}
    }),

    computed: {
      // Stavke izvoda koje vec imaju knjizenje (ConnId = id stavke izvoda), ali nisu zatvorene.
      povezaneSideId () {
        const m = {}
        const stavke = this.$store.state.mainledgerItems || []
        stavke.forEach(i => { if (i && i.ConnId) { m[i.ConnId] = true } })
        return m
      },
      brojStatusa () {
        const r = { proknjizeno: 0, djelomicno: 0, otvoreno: 0 }
        this.mldetails.forEach(x => { r[this.statusRetka(x).kljuc]++ })
        return r
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    async mounted() {
      if (this.$store.state.language === "EN") {
        this.lang = ledgerEN
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.lang = ledgerHR
        this.langC = commHr;
      }
      if (this.$store.state.companyid) {
        this.mainQuery.CompanyId = this.$store.state.companyid
        this.defaultItem.CompanyId = this.$store.state.companyid
      }
      this.$store.dispatch('setMainLedgerSideItem', null)
      
      this.defaultItem.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
      this.mainQuery.businessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2020
      
      //this.mainQuery.databaseMLID = this.$store.state.mainledgerActiv.id ? this.$store.state.mainledgerActiv.id : 0
      this.mainQuery.databaseMLID = this.$store.state.mainledgerid ? this.$store.state.mainledgerid : 0
      await this.ucitajStavke()
      this.documentName = this.$store.state.documentActiv
      this.documentNameLoc = this.$store.state.documentActivLoc

      this.headers.push(
        { text: this.lang.detailDone, align: 'left', sortable: true, value: 'ClosedAccount', width: '120px' },
        { text: this.lang.detailId, align: 'left', sortable: true, value: 'bankStatmentNumberDetail', width: '60px' },
        { text: this.lang.partnerName + ' / IBAN', align: 'left', sortable: true, value: 'partnerName' },
        { text: this.lang.Description, align: 'left', sortable: true, value: 'bankDescription' },
        { text: this.lang.bankStatmentDebit, align: 'right', sortable: true, value: 'bankStatmentDebit', width: '130px' },
        { text: this.lang.bankStatmentCredit, align: 'right', sortable: true, value: 'bankStatmentCredit', width: '130px' }
      )
    },
    created () {
      this.initialize()
    },

    methods: {
      // Stavke izvoda (MainLedgerSides); ponovno se zovu nakon potvrde prijedloga knjizenja.
      async ucitajStavke () {
        const { data } = await MainLedgerService.indexbsdetails(this.mainQuery)
        if (data.mainledgerDetails && data.mainledgerDetails.length > 0) {
          this.mldetails = data.mainledgerDetails
          this.$store.dispatch('setMainLedgerSideItems', data.mainledgerDetails)
        }
      },
      broj (v) { return parseFloat(v) || 0 },
      statusRetka (item) {
        if (item.ClosedAccount) { return { klasa: 'ok', kljuc: 'proknjizeno', tekst: 'proknjiženo' } }
        if (this.povezaneSideId[item.id]) { return { klasa: 'dj', kljuc: 'djelomicno', tekst: 'djelomično' } }
        return { klasa: 'otv', kljuc: 'otvoreno', tekst: 'otvoreno' }
      },
      pozivPlatitelja (item) {
        return [item.bankReference1, item.bankReference2].filter(x => x).join(' ')
      },
      pozivPrimatelja (item) {
        return [item.bankCall1, item.bankCall2].filter(x => x).join(' ')
      },
      // Pozivi na broj u jednom retku; prazno ako ih nema.
      pozivi (item) {
        const dijelovi = []
        if (this.pozivPlatitelja(item)) { dijelovi.push('PNB plat.: ' + this.pozivPlatitelja(item)) }
        if (this.pozivPrimatelja(item)) { dijelovi.push('PNB prim.: ' + this.pozivPrimatelja(item)) }
        return dijelovi.join(' · ')
      },
      // Trazenje po svim vidljivim podacima retka (ukljucujuci IBAN i pozive na broj iz sivog dijela).
      filtrirajRed (value, search, item) {
        const q = String(search || '').toLowerCase()
        if (!q) { return true }
        const polja = [item.partnerName, item.partnerBankIBAN, item.bankReference1, item.bankReference2,
          item.bankCall1, item.bankCall2, item.bankDescription, item.bankCode, item.bankStatmentNumberDetail,
          this.formatPrice(item.bankStatmentDebit), this.formatPrice(item.bankStatmentCredit)]
        return polja.some(p => p !== null && p !== undefined && String(p).toLowerCase().indexOf(q) !== -1)
      },
      formatPrice (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      formatPriceHR (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      haveAlert(params) {
        // if is book in or book out
        this.para = params
        this.showAlert = false
        if (this.para.ClosedAccount) {
          if (this.$store.state.language === "EN") {
            this.alertText1 = 'Accounting warning!'
            this.alertText2 = 'You choose to book item that are already booked. Are you shure?'
          }
          if (this.$store.state.language === "HR") {
            this.alertText1 = 'Knjiženje - upozorenje!'
            this.alertText2 = 'Odabrali ste za želite knjižiti stavku koja je već proknjižena. Da li ste sigurni?'
          }
          this.showAlert = true
        }
        if (!this.showAlert) {
          this.navigateTo ()
        }
      },
      haveAlert2() {
        this.showAlert = false
        this.navigateTo ()
      },
      async navigateTo () {
        this.$store.dispatch('setMainLedgerSideItem', this.para)
        // this.$store.dispatch('setMainLedgerTotals', 1)
        this.$store.dispatch('setConnId', this.para.id)
        this.$store.dispatch('setConnName', this.$store.state.mainledgerActiv.documentIdGeneral ? this.$store.state.mainledgerActiv.documentIdGeneral : null) 
        this.$store.dispatch('seteditItem', 0)
        this.$router.push({
          name: 'mainledgerdetailcreate'
        })
        // this.$router.push({
        //   name: 'mainledgerview'
        // })
      },

      async initialize () {
        try {
          // this.saving = true
          // this.mldetails = (await MainLedgerDetailService.index(this.$store.state.mainledgerid)).data.mainledgerDetails
          // this.saving = false
          this.errorMatch = false
          this.editedItem = this.defaultItem
          this.select = {}
          this.selectA4 = {}
        } catch (err) {
          this.error = err
        }
      },
      editItem (item) {
        this.errorMatch = false
        this.editedIndex = this.mldetails.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
          const index = this.mldetails.indexOf(item)
          const warningMessage = item.account4 + ' ' + item.account4Description
          if (confirm(this.langC.AreYouShureToDelete + ' ' + warningMessage + '!') && this.mldetails.splice(index, 1)) {
            this.makesum()
          }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.mldetails[this.editedIndex], this.editedItem)
        } else {
          this.mldetails.push(this.editedItem)
        }
      },

      localDate(dateToFormat) {
       return dateFormat(dateToFormat)
      },

    },
  }
</script>

<style scoped>
.bs-tablica { border: 1px solid rgba(0,0,0,.12); border-radius: 4px; overflow: hidden; }
.bs-tablica >>> .v-data-table__wrapper { overflow-x: auto; }
.bs-tablica >>> thead th { background: #fafafa !important; font-size: 12px !important; color: rgba(0,0,0,.6) !important; }
.bs-tablica >>> tbody tr { cursor: pointer; }
.bs-tablica >>> tbody tr:hover { background: #eef4fb !important; }
.bs-tablica >>> tbody td { padding-top: 6px; padding-bottom: 6px; vertical-align: top; }
.bs-glava { background: #eef4fb !important; border-bottom: 2px solid #1976d2; }
.bs-glava >>> .v-toolbar__content { flex-wrap: wrap; height: auto !important; min-height: 48px; gap: 6px; }
.bs-naslov { font-size: 17px; font-weight: 700; color: #1565c0; }
.bs-trazi { max-width: 260px; }
.bs-brojke { margin-left: 14px; }
.bs-oz { display: inline-block; font-size: 12px; border-radius: 10px; padding: 1px 9px; margin-right: 4px; white-space: nowrap; }
.bs-oz-ok { background: #e8f5e9; color: #2e7d32; }
.bs-oz-dj { background: #fff4e0; color: #b26a00; }
.bs-oz-otv { background: #eceff1; color: #546e7a; }
.bs-rbr { color: rgba(0,0,0,.75); font-size: 15px; font-weight: 500; font-variant-numeric: tabular-nums; }
.bs-redak1 { display: flex; align-items: baseline; gap: 8px; min-width: 0; max-width: 460px; }
.bs-partner { font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; flex: 0 1 auto; }
.bs-sitno { font-size: 12px; color: rgba(0,0,0,.6); }
.bs-iban { flex: 0 0 auto; white-space: nowrap; font-variant-numeric: tabular-nums; }
.bs-redak2 { max-width: 460px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bs-opis { font-size: 13px; max-width: 360px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bs-iznos { font-size: 16px; font-weight: 600; white-space: nowrap; font-variant-numeric: tabular-nums; }
.bs-iznos small { margin-left: 4px; font-weight: 400; font-size: 11px; opacity: .8; }
.bs-d { color: #c62828; }
.bs-p { color: #2e7d32; }
.bs-nula { color: rgba(0,0,0,.35); }
</style>
